import plugin from 'tailwindcss/plugin'

import { convertWeight, pxToRem } from './typography'

export const cardboardTypographyConfig = {
  light: {
    title: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(37),
      lineHeight: pxToRem(46),
    },
    heading: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(29),
      lineHeight: pxToRem(36),
    },
    subheading: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(24),
      lineHeight: pxToRem(30),
    },
    subheading2: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(21),
      lineHeight: pxToRem(26),
    },
    body: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    button: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    caption: {
      fontWeight: convertWeight('regular'),
      fontSize: pxToRem(15),
      lineHeight: pxToRem(19),
    },
    tiny: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(13),
      lineHeight: pxToRem(16),
    },
  },
  default: {
    title: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(37),
      lineHeight: pxToRem(46),
    },
    heading: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(29),
      lineHeight: pxToRem(36),
    },
    subheading: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(24),
      lineHeight: pxToRem(30),
    },
    subheading2: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(21),
      lineHeight: pxToRem(26),
    },
    body: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    button: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    caption: {
      fontWeight: convertWeight('medium'),
      fontSize: pxToRem(15),
      lineHeight: pxToRem(19),
    },
    tiny: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(13),
      lineHeight: pxToRem(16),
    },
  },
  heavy: {
    title: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(37),
      lineHeight: pxToRem(46),
    },
    heading: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(29),
      lineHeight: pxToRem(36),
    },
    subheading: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(24),
      lineHeight: pxToRem(30),
    },
    subheading2: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(21),
      lineHeight: pxToRem(26),
    },
    body: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    button: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(17),
      lineHeight: pxToRem(21),
    },
    caption: {
      fontWeight: convertWeight('demibold'),
      fontSize: pxToRem(15),
      lineHeight: pxToRem(19),
    },
    tiny: {
      fontWeight: convertWeight('bold'),
      fontSize: pxToRem(13),
      lineHeight: pxToRem(16),
    },
  },
}

export const cardboardTypography = Object.entries(
  cardboardTypographyConfig,
).reduce((typography, [weightName, weightConfig]) => {
  Object.entries(weightConfig).forEach(([styleName, styleConfig]) => {
    const name = `.text-${styleName}-${weightName}`

    typography[name] = {
      fontFamily: [
        'TT Commons',
        '-apple-system',
        'BlinkMacSystemFont',
        'Helvetica',
        'sans-serif',
      ].join(', '),
      fontSize: styleConfig.fontSize,
      lineHeight: styleConfig.lineHeight,
      fontWeight: `${styleConfig.fontWeight}`,
    }
  })

  return typography
}, {} as Record<string, Partial<CSSStyleDeclaration>>)

export const cardboardTypographyPlugin = plugin(function circuitDarkMode({
  addBase,
}) {
  addBase(cardboardTypography)
})
